'use client'

// SUMMARY: Navbar help button - opens this page's guide, disabled on pages that do not have one.

import { useState } from 'react'
import { usePathname } from 'next/navigation'
import { useTranslations } from 'next-intl'
import { HelpCircle } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { getGuideForPath } from '@/lib/guides/registry'
import { GuideOverlay } from './guide-overlay'

export function GuideButton() {
	const t = useTranslations('guide')
	const pathname = usePathname()
	const guide = getGuideForPath(pathname)
	const [open, setOpen] = useState(false)

	return (
		<>
			<Tooltip>
				<TooltipTrigger
					onClick={() => setOpen(true)}
					disabled={!guide}
					aria-label={t('open')}
					className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-accent hover:text-foreground disabled:cursor-default disabled:opacity-40 disabled:hover:bg-transparent disabled:hover:text-muted-foreground"
				>
					<HelpCircle className="h-[18px] w-[18px]" />
				</TooltipTrigger>
				<TooltipContent>{guide ? t('open') : t('unavailable')}</TooltipContent>
			</Tooltip>

			{open && guide && <GuideOverlay steps={guide.steps} onClose={() => setOpen(false)} />}
		</>
	)
}
